import { Navigate } from "react-router-dom";
import { useAuthStore } from "@/store/authStore";
import type { JSX } from "react";

interface PublicRouteProps {
    children: JSX.Element;
}

export const PublicRoute = ({ children }: PublicRouteProps) => {
    const { isAuthenticated, loading } = useAuthStore();
   
    // While checking auth, don't redirect yet
    if (loading) {
        return <div className="p-6 text-center">Checking authentication...</div>;
    }

    // Logged in → redirect away from login/signup
    if (isAuthenticated) {
        return <Navigate to="/" replace />;
    }

    // Not authenticated → allow entry
    return children;
};
